const productCategory = [
    { id : 1, label : "Earings", value : "earings"},
    { id : 2, label : "Chandbalis", value : "chandbalis"},
    { id : 3, label : "Neckless", value : "neckless"},
    { id : 4, label : "Rings", value : "rings"},
    { id : 5, label : "Jewellery Sets", value : "jewellery sets"},
    { id : 6, label : "Claw Clips", value : "claw clips"},
    { id : 7, label : "Anti Tarnish", value : "anti tarnish"},
    { id : 8, label : "Bracelets", value : "bracelets"},
    { id : 9, label : "Nose Pins", value : "nose pins"},
    { id : 10, label : "Hair Accessories", value : "hair accessories"},
    { id : 11, label : "Mangalsutra", value : "mangalsutra"},
    { id : 12, label : "Bangles", value : "bangles"},
]

export default productCategory;